interface EditorDraftNoticeProps {
  savedAt?: string;
  isDirty: boolean;
  notice: string | null;
  storageError: string | null;
  onRestore: () => void;
  onDiscard: () => void;
}

export function EditorDraftNotice(props: EditorDraftNoticeProps) {
  if (props.savedAt) {
    return (
      <div className="card" data-testid="editor-draft-recovery" role="status">
        <p>You have an unfinished draft from <time dateTime={props.savedAt}>{new Date(props.savedAt).toLocaleString()}</time>.</p>
        {props.storageError && <p className="error-box" role="alert">{props.storageError}</p>}
        <div className="builder-header-actions">
          <button type="button" className="btn btn-primary" onClick={props.onRestore}>Restore draft</button>
          <button type="button" className="btn btn-ghost" onClick={props.onDiscard}>Discard draft</button>
        </div>
      </div>
    );
  }
  return (
    <p className={props.storageError ? 'error-box' : 'muted faint'} role="status" data-testid="editor-draft-status">
      {props.storageError ?? props.notice ?? (props.isDirty
        ? 'Unsaved changes · recovery draft kept in this browser.'
        : 'Your edits are kept in this browser until you save.')}
    </p>
  );
}
